import React, { useState } from 'react'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import { useAuthDataContext } from '../../../../_providers/Auth'
import { trans } from '../../../../_providers/Translation'

function FilterTabs(props) {
    const auth = useAuthDataContext()

    const [tabs, setTabs] = useState({
        ripple: true
    })

    const handleTabs = (e, newValue) => {
        props.handleTab(newValue)
    }

    return (
        <Tabs
            value={props.tab}
            onChange={handleTabs}
            variant="scrollable"
            scrollButtons="auto"
            indicatorColor="primary"
            textColor="primary"
            aria-label="scrollable force tabs"
        >
            {props.showSettingsTab &&
                <Tab value="neccesary-settings" label={trans('tabs.home')} disableRipple={tabs.ripple} />
            }
            <Tab value="info" label={trans('tabs.mainInfo')} disableRipple={tabs.ripple} />
            <Tab value="employees" label={trans('tabs.employees')} disableRipple={tabs.ripple} />
            {auth.isManager() &&
                <Tab value="groups" label={trans('tabs.groups')} disableRipple={tabs.ripple} />
            }
            {auth.isManager() &&
                <Tab value="settings" label={trans('tabs.settings')} disableRipple={tabs.ripple} />
            }
            {auth.isManager() &&
                <Tab value="activity-log" label={trans('headings.activityLog')} disableRipple={tabs.ripple} />
            }
            {auth.isManager() &&
                <Tab value="login-history" label={trans('tabs.loginHistory')} disableRipple={tabs.ripple} />
            }
            {auth.isManager() &&
                <Tab value="data-export" label={trans('tabs.dataExport')} disableRipple={tabs.ripple} />
            }
        </Tabs>
    )
}

export default FilterTabs